// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--94684";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--15dc1";
export var pageBody = "detailsPage-module--page-body--7a739";
export var pageFooter = "detailsPage-module--page-footer--e833e";
export var pageFooterBack = "detailsPage-module--page-footer-back--e9c58";
export var pageIntro = "detailsPage-module--page-intro--e0331";
export var pageIntroContainer = "detailsPage-module--page-intro-container--4e45d";
export var pageIntroImg = "detailsPage-module--page-intro-img--6c7a3";
export var pageIntroImgFull = "detailsPage-module--page-intro-img-full--f128a";
export var pageIntroTaxoContainer = "detailsPage-module--page-intro-taxo-container--03483";
export var pageIntroTitle = "detailsPage-module--page-intro-title--6672c";
export var pageTaxo = "detailsPage-module--page-taxo--8b6f4";